export default class CollectionFilter {
    filterContainer = null;
    resultsContainer = null;
    filtering = false;

    selected = [];
    currentSort = '';
    
    filterGroups = [];
    filterToggles = [];
    sortbyToggles = [];

    options = {
        filterContainerSelector: '[mx-collection-filter]',
        resultsContainerSelector: '[mx-filter-results]',
        filterGroupSelector: '[mx-filter-group]',
        filterToggleSelector: '[mx-filter-toggle]',
        sortbyToggleSelector: '[mx-sortby-toggle]',
        resultSelector: '[mx-filter-result]',
        numResultsSelector: '[mx-num-results]',
        filterReadyClass: 'filter-ready',

        filterHashName: 'filters',
        sortbyHashName: 'sort',

        numResultsText: 'Showing %X result', // Replaces %X with the number of results
        numResultsTextPlural: 'Showing %X results', // Replaces %X with the number of results

        beforeFilterCallback: null,
        afterFilterCallback: null, 
        beforeSortCallback: null,
        afterSortCallback: null,
        initCallback: null,
    }

    constructor(options = {}) {

        this.options = { ...this.options, ...options };
        
        this.filterContainer = document.querySelector(this.options.filterContainerSelector);
        if( this.filterContainer ) {
            this.resultsContainer = document.querySelector(this.options.resultsContainerSelector);
            this.filterGroups = document.querySelectorAll(this.options.filterGroupSelector);
            this.filterToggles = document.querySelectorAll(this.options.filterToggleSelector);
            this.sortbyToggles = document.querySelectorAll(this.options.sortbyToggleSelector);
            
            this.options.defaultSort = this.filterContainer.getAttribute('data-default-sort');
            this.currentSort = this.options.defaultSort;

            this.filterGroups.forEach((group) => {
                this.selected.push( { handle: group.getAttribute('data-group'), filters: [] } );
            });

            // Prevent bootstrap dropdowns from closing when clicking inside the menu
            this.filterContainer.querySelectorAll('.dropdown-menu').forEach(menu => {
                menu.addEventListener('click', e => e.stopPropagation());
            });

            // For each filter, if it has a checkbox input, toggle the filter on change event,
            // if not, toggle the filter on click event
            this.filterToggles.forEach((toggle) => {
                const checkbox = toggle.querySelector('input[type=checkbox]');
                if (checkbox) {
                    checkbox.addEventListener('change', () => this.toggleFilter(toggle.getAttribute('data-group'), toggle.getAttribute('data-filter'))); 
                } else {
                    toggle.addEventListener('click', () => this.toggleFilter(toggle.getAttribute('data-group'), toggle.getAttribute('data-filter'))); 
                }
            });

            this.sortbyToggles.forEach((toggle) => {  
                const radio = toggle.querySelector('input[type=radio]');
                const sortby = toggle.getAttribute('data-sortby');
                if (radio) {
                    radio.addEventListener('change', () => this.sort(sortby));
                } else {
                    toggle.addEventListener('click', () => this.sort(sortby));
                }
            });

            // this.checkCollection();
            this.checkHash();
            this.sort();
            this.filter();

            // Prevents flash of products before the initial filters are processed from the hash
            this.filterContainer.classList.add(this.options.filterReadyClass);
            this.resultsContainer.classList.add(this.options.filterReadyClass); 
        }

        if (this.options.initCallback) {
            this.options.initCallback();
        }

    }

    // Called on initial load
    checkCollection() {
        const path  = window.location.pathname
        if( path.indexOf('collections') > -1){
            const collection = path.split( '/').pop();
            if( $('[data-filter-without-group="'+ collection +'"]').length > 0 ){
                const data = $('[data-filter-without-group="'+ collection +'"]').data();
                const handle = data.group;
                let selection = app.selected.find( selected => {
                    return selected.handle == handle;
                })
                if( selection != undefined ) selection.filters.push( data.filter ) 
            }
        }
    }

    // Called on initial load to update the filters based on the URL
    checkHash() {
        let hash = window.location.hash;
        if( hash.indexOf('#'+this.options.filterHashName+'=') > -1){
            let filterHash = hash.replace('#'+this.options.filterHashName+'=', '');
            filterHash = filterHash.split( '|' );
            filterHash.forEach(( group ) => {
                let filters = group.split('=');
                const handle = filters[0];
                if (handle === this.options.sortbyHashName) {
                    if (filters[1] && filters[1] !== '') {
                        this.currentSort = filters[1];
                    }
                } else if (filters.length > 1) {
                    filters = filters[1].split(',');
                    let selection = this.selected.find( selected => selected.handle == handle );
                    if( selection != undefined ){
                        filters.forEach((filter) => {
                            selection.filters.push( filter ) 
                        })
                    }
                }

            });					
        }

        this.updateToggleElements();
    }

    // Called after a filter/sort
    updateHash() {

        let hash = '#'+this.options.filterHashName+'=';
        if( !this.filtering ){
            hash += '|' + this.options.sortbyHashName + '=' + this.currentSort;
            window.location.hash = hash;
            return;
        }
        let groups = [];
        this.selected.forEach( selection => {
            let filters_ = [];
            if( selection.filters.length  > 0 ){
                selection.filters.forEach( filter => {
                    filters_.push( filter.replace( selection.handle , '' ).replace( '_' , '') ) ;
                })
                filters_ = filters_.join( ',');
                filters_ = selection.handle + '=' + filters_;
                groups.push( filters_ );
            }
        })
        if( groups.length > 0 ){
            hash = hash + groups.join( '|');
            hash += '|' + this.options.sortbyHashName + '=' + this.currentSort;
            window.location.hash = hash;
        }
    }

    toggleFilter(dataGroup, dataFilter ) {
        if (dataGroup === "clear-all-filters") {
            this.selected = [];
            this.filterGroups.forEach((group) => {
                this.selected.push( { handle: group.getAttribute('data-group'), filters: [] } );
            });
        } else {
            let group = this.selected.find( group => group.handle == dataGroup );
            let exists = group.filters.find( filter => filter == dataFilter );

            if( !exists ) {
                group.filters.push( dataFilter )
            } else {
                group.filters = group.filters.filter( filter => dataFilter !== filter );
            }
        }
        this.updateToggleElements();
        this.filter() 
    }

    updateToggleElements() {
        let isActive = false;
        this.filterToggles.forEach((toggle) => {
            const dataFilter = toggle.getAttribute('data-filter');
            const dataGroup = toggle.getAttribute('data-group');
            const checkbox = toggle.querySelector('input[type=checkbox]');

            for (let i = 0; i < this.selected.length; i++) {
                if (dataGroup !== this.selected[i].handle) continue;
                this.selected[i].filters.forEach((filter) => {
                    if (filter === dataFilter) {
                        isActive = true;
                    }
                })
            }

            if (isActive) {
                toggle.setAttribute('data-filter-active', true);
                if (checkbox) {
                    checkbox.checked = true;
                }
            } else {
                toggle.removeAttribute('data-filter-active');
                if (checkbox) {
                    checkbox.checked = false;
                }
            }
            isActive = false;
        })
    }

    filter() {
        if (this.options.beforeFilterCallback) {
            this.options.beforeFilterCallback();
        }
        
        // build a group of arrays for identifiers and get the intersection
        let cids = [];
        this.filtering = false;
        this.selected.forEach( group => {
            let group_cids = [];
            group.filters.forEach( filter => {
                this.resultsContainer.querySelectorAll(this.options.resultSelector).forEach((result) => {
                    let id = result.getAttribute('data-product-id');
                    if (result.classList.contains( filter )) {
                        group_cids.push( parseInt( id ) );
                    }
                });
            })
            if ( group_cids.length > 0 ) {
                cids.push( group_cids )
                this.filtering = true 
            }
        })
        let num_results = 0;
        if ( this.filtering ){
            cids = this.intersectMany( ...cids );
            // find the container with results and show only the ones in the intersect array 
            this.resultsContainer.querySelectorAll(this.options.resultSelector).forEach((result) => {
                if ( cids.indexOf(parseInt(result.getAttribute('data-product-id'))) > -1 ) {
                    result.style.display = 'block';
                    num_results++;
                } else {
                    result.style.display = 'none';
                }
            });
        }
        if( !this.filtering ){
            this.filtering = false;
            this.resultsContainer.querySelectorAll(this.options.resultSelector).forEach((result) => {
                result.style.display = 'block';
                num_results++;
            })
        }

        document.querySelectorAll(this.options.numResultsSelector).forEach(ele => {
            if (num_results === 1) {
                ele.innerHTML = this.options.numResultsText.replaceAll('%X', num_results);
            } else if ( num_results === 0 ) {
                ele.innerHTML = "No results found";
            } else {
                ele.innerHTML = this.options.numResultsTextPlural.replaceAll('%X', num_results);
            }
        });
        this.updateHash()

        // SHOW No Fish For You and HIDE Smoke if 0
        const productGrid = document.querySelector('.section-product-grid');
        const noFish = document.querySelector('.noFish');
        if ( num_results === 0) {
            productGrid.classList.add("hidden");
            noFish.classList.add("show");
        } else {
            productGrid.classList.remove("hidden");
            noFish.classList.remove("show");
        }

        if (this.options.afterFilterCallback) {
            this.options.afterFilterCallback();
        }
    }

    // Sorting
    sort( sortby = null, title) {
        const sortByText = document.querySelector('[mx-sort-by-text]');
        if (this.options.beforeSortCallback) {
            this.options.beforeSortCallback();
        }

        if (!sortby) {
            sortby = this.currentSort
        } else {
            this.currentSort = sortby;
        }
        let items = [];
        this.resultsContainer.querySelectorAll(this.options.resultSelector).forEach((result) => {
            items.push(result);
        });

        switch (sortby) {
            case 'featured': {
                sortByText.innerHTML = 'Sorting By Featured';
                items.sort(this.sortbyFeatured );
                break;
            }
            case 'title-ascending': {
                sortByText.innerHTML = 'Sorting By Title A-Z';
                items.sort(this.sortbyTitleAscending);
                break;
            }
            case 'title-descending': {
                sortByText.innerHTML = 'Sorting By Title Z-A';
                items.sort(this.sortbyTitleDescending);
                break;
            }
            case 'price-ascending': {
                sortByText.innerHTML = 'Sorting By Price Lowest';
                items.sort(this.sortbyPriceAscending);
                break;
            }
            case 'price-descending': {
                sortByText.innerHTML = 'Sorting By Price Highest';
                items.sort(this.sortbyPriceDescending);
                break;
            }
            case 'date-ascending': {
                sortByText.innerHTML = 'Sorting By Date Old to New';
                items.sort(this.sortbyDateAscending);
                break;
            }
            case 'date-descending': {
                sortByText.innerHTML = 'Sorting By Date New to Old';
                items.sort(this.sortbyDateDescending);
                break;
            }
            default: 
                // In case the string is malformed, choose a basic sort that should exist
                this.currentSort = 'title-ascending'; 
                sortByText.innerHTML = 'Sorting By Title A-Z';
                items.sort(this.sortbyTitleAscending);
                break;
        }

        items.forEach(item => {
            this.resultsContainer.append(item);
        });

        this.sortbyToggles.forEach((toggle) => {
            toggle.removeAttribute('data-sort-active');
            if (toggle.getAttribute('data-sortby') === this.currentSort) {
                toggle.setAttribute('data-sort-active', true);
                const radio = toggle.querySelector('input[type=radio]');
                if (radio) {
                    radio.checked = true;
                }
            }
        })

        this.updateHash();

        if (this.options.afterSortCallback) {
            this.options.afterSortCallback();
        }
    }

    intersection(arr1, arr2) {
        const res = [];
        for(let i = 0; i < arr1.length; i++){
           if(!arr2.includes(arr1[i])){
              continue;
           };
           res.push(arr1[i]);
        };
        return res;
    };
    intersectMany(...arrs) {
        let res = arrs[0].slice();
        for(let i = 1; i < arrs.length; i++){
            res = this.intersection(res, arrs[i]);
        };
        return res;
    }; 

    sortbyFeatured(a, b) {
        a = +a.getAttribute('data-index');
        b = +b.getAttribute('data-index');
        if (a < b)
            return -1;
        if (a > b)
            return 1;
        return 0;
    }
    sortbyTitleAscending(a, b) {
        let titleA = a.getAttribute('data-title').toLowerCase();
        let titleB = b.getAttribute('data-title').toLowerCase();
        if (titleA < titleB)
            return -1;
        if (titleA > titleB)
            return 1;
        return 0;
    }
    sortbyTitleDescending(a, b) {
        let titleA = a.getAttribute('data-title').toLowerCase();
        let titleB = b.getAttribute('data-title').toLowerCase();
        if (titleA > titleB)
            return -1;
        if (titleA < titleB)
            return 1;
        return 0;
    }
    sortbyPriceAscending(a, b) {
        a = +a.getAttribute('data-price');
        b = +b.getAttribute('data-price');
        if (a < b)
            return -1;
        if (a > b)
            return 1;
        return 0;
    }
    sortbyPriceDescending(a, b) {
        a = +a.getAttribute('data-price');
        b = +b.getAttribute('data-price');
        if (a > b)
            return -1;
        if (a < b)
            return 1;
        return 0;
    }
    sortbyDateDescending(a, b) {
        let dateA = new Date(a.getAttribute('data-date').split(' ')[0].replace(/-/g, "/"));
        let dateB = new Date(b.getAttribute('data-date').split(' ')[0].replace(/-/g, "/"));
        if (dateA > dateB)
            return -1;
        if (dateA < dateB)
            return 1;
        return 0;
    }
    sortbyDateAscending(a, b) {
        let dateA = new Date(a.getAttribute('data-date').split(' ')[0].replace(/-/g, "/"));
        let dateB = new Date(b.getAttribute('data-date').split(' ')[0].replace(/-/g, "/"));
        if (dateA < dateB)
            return -1;
        if (dateA > dateB)
            return 1;
        return 0;
    }
}